import * as yup from 'yup'

export const whatsappSchema = yup.object({
	telephone: yup
		.string()
		.trim()
		.test('len', 'Must be exactly 11 characters', (val) => val?.length === 11)
		.required('* Preencha os campos obrigatórios.'),
})
